module.exports = __webpack_public_path__ + "static/media/circle.2d975615.svg";